import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { useL2DTheme } from '@europrocurement/flexy-components';
import { useDomainStatusStyle } from '@europrocurement/l2d-modules';

type DomainCardProps = {
    domainName: string;
    statutId?: number;
    statutLibelle?: string;
    dateDebut?: string;
};

const DomainCard: React.FunctionComponent<DomainCardProps> = function ({
    domainName,
    statutId,
    statutLibelle,
    dateDebut,
}) {
    const { palette } = useL2DTheme();
    const { getDomainStatusStyle } = useDomainStatusStyle();
    const { isInactive, dotColor, cardSx, chipSx } = getDomainStatusStyle(statutId);
    const label = statutLibelle ?? 'Non activé';

    return (
        <Box
            sx={{
                p: 1.5,
                borderRadius: 1,
                opacity: isInactive ? 0.55 : 1,
                height: '100%',
                width: '100%',
                ...cardSx,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 0.75,
                    mb: 0.5,
                }}
            >
                <Box
                    sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: dotColor,
                        flexShrink: 0,
                    }}
                />
                <Chip
                    label={label}
                    size="small"
                    sx={{
                        height: 18,
                        fontSize: '10px',
                        fontWeight: 600,
                        borderRadius: '0.5em',
                        ...chipSx,
                    }}
                />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, fontSize: '12px', color: palette.text.primary }}
                >
                    {domainName}
                </Typography>
                {dateDebut && (
                    <Typography
                        variant="caption"
                        sx={{ color: palette.text.secondary, fontSize: '11px' }}
                    >
                        Depuis {new Date(dateDebut).toLocaleDateString('fr-FR')}
                    </Typography>
                )}
                {isInactive && (
                    <Typography
                        variant="caption"
                        sx={{ color: palette.text.disabled, fontSize: '11px', fontStyle: 'italic' }}
                    >
                        Non actif
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default DomainCard;
